import React from 'react';
import { ArrowRightIcon, WalletIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
export function PaymentFees() {
  return <section className="w-full bg-white pb-20" aria-labelledby="fees-heading" data-id="element-985" data-mp="1c09ucgd6rn5m">
      <div className="mx-auto max-w-shell px-6" data-id="element-986" data-mp="1qo4lvtfgjlh4">
        <div className="grid grid-cols-1 gap-6 rounded-[14px] border border-canvas-line bg-canvas-warm p-8 md:grid-cols-[auto_minmax(0,1fr)_auto] md:items-center md:gap-8" data-id="element-987" data-mp="1lwmo1e8qe10d">
          <span className="flex h-11 w-11 items-center justify-center rounded-[10px] border border-canvas-line bg-white text-brand" data-id="element-988" data-mp="1zq45mthux3nr">
            <WalletIcon className="h-5 w-5" strokeWidth={1.9} aria-hidden="true" data-id="element-989" data-mp="29lxdhzkms8z7" />
          </span>
          <div data-id="element-990" data-mp="24ndsc1dv317w">
            <h2 id="fees-heading" className="text-[20px] font-semibold tracking-[-0.02em] text-ink" data-id="element-991" data-mp="24mujda66vn60">
              Payment fees
            </h2>
            <p className="mt-2 max-w-[640px] text-[15px] leading-[1.6] text-ink-muted" data-id="element-992" data-mp="f8fxcxmk2ee7">
              Kayko does not add a payment transaction fee. Charges from mobile money, card or bank-transfer
              providers may still apply, and vary by payment method.
            </p>
          </div>
          <SmartLink href="/legal/fees" className="inline-flex shrink-0 items-center gap-1.5 text-[15px] font-semibold text-brand transition-colors duration-150 ease-out hover:text-brand-hover" data-id="element-993" data-mp="28l6g1ox3ethl">
            See full fee schedule
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-994" data-mp="2n8rjjjxvquq1" />
          </SmartLink>
        </div>
      </div>
    </section>;
}